import React, { useState } from "react";
import { uploadMedia } from "../../services/galleryService";
import { formatFileSize } from "../../utils/helpers";
import Button from "../../components/common/Button";
import { toast } from "react-toastify";
import PrivacyPolicyModal, { hasAcceptedPrivacy } from "../../components/common/PrivacyPolicyModal";
import { useAuth } from "../../context/AuthContext";

const UploadMedia = () => {
  const { user } = useAuth();
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  const doUpload = async () => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));

    setUploading(true);
    try {
      await uploadMedia(formData);
      toast.success("Upload successful!");
      setFiles([]);
    } catch {
      toast.error("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleUpload = () => {
    if (files.length === 0) {
      toast.warning("Please select at least one file.");
      return;
    }
    if (hasAcceptedPrivacy(user?.Email)) {
      doUpload();
    } else {
      setShowPrivacyModal(true);
    }
  };

  return (
    <>
      {showPrivacyModal && (
        <PrivacyPolicyModal
          onAccept={() => { setShowPrivacyModal(false); doUpload(); }}
          onDecline={() => setShowPrivacyModal(false)}
        />
      )}
    <div>
      <h2 style={styles.heading}>Upload Media</h2>

      <div style={styles.card}>
        <label style={styles.dropzone}>
          <input
            type="file"
            multiple
            accept="image/*,video/*,.mov,.avi,.mkv,.wmv,.webm,.flv,.m4v,.3gp,.ts,.mts"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <span style={styles.dropText}>📁 Click to select photos or videos</span>
        </label>

        {files.length > 0 && (
          <ul style={styles.fileList}>
            {files.map((f, i) => (
              <li key={i} style={styles.fileItem}>
                <span>{f.name}</span>
                <span style={styles.size}>{formatFileSize(f.size)}</span>
              </li>
            ))}
          </ul>
        )}

        <Button onClick={handleUpload} disabled={uploading} style={{ marginTop: 20 }}>
          {uploading ? "Uploading..." : `Upload ${files.length > 0 ? `(${files.length})` : ""}`}
        </Button>

        <p style={styles.uploadNote}>
          Your browser may ask for permission to access the selected files or folder. This permission is required only to upload the media you choose.
        </p>
      </div>
    </div>
    </>
  );
};

const styles = {
  heading: { margin: "0 0 20px", fontSize: 22, fontWeight: 700, color: "#1e1e2d" },
  card: {
    background: "#fff",
    borderRadius: 12,
    padding: 28,
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    maxWidth: 560,
  },
  dropzone: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px dashed #c0b9ff",
    borderRadius: 10,
    height: 140,
    cursor: "pointer",
    background: "#f9f8ff",
  },
  dropText: { fontSize: 15, color: "#6c63ff", fontWeight: 500 },
  fileList: { margin: "16px 0 0", padding: 0, listStyle: "none" },
  fileItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    borderBottom: "1px solid #f0f0f0",
    fontSize: 13,
    color: "#444",
  },
  size: { color: "#888" },
  uploadNote: {
    margin: "12px 0 0",
    fontSize: 12,
    lineHeight: 1.5,
    color: "#666",
  },
};

export default UploadMedia;
